var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('pie-revenue-segment'),_c('pie-revenue-witel'),_c('div',{staticClass:"row"},[_c('pie-panjar'),_c('pie-jps')],1),_c('stacked-outlook')],1)}
var staticRenderFns = []

export { render, staticRenderFns }